<!-- <div class="d-flex flex-row" [class.justify-content-center]="!alignLeft" [class.center-vertically]="centerVertically" [class.align-items-center]="centerVertically">
    <div *ngIf="!timeout" class="sp sp-circle" [class.m-0]="noMargin"></div>
</div> -->

<div class="d-flex flex-row" [class.justify-content-center]="!alignLeft" [class.center-vertically]="centerVertically" [class.align-items-center]="centerVertically" [class.fixed]="fixed">
    <div *ngIf="!timeout" class="sp sp-circle" [class.m-0]="noMargin" [style.height]="spinnerHeight" [style.width]="spinnerWidth"></div>
</div>